// 三类申请（彩票投注站 / 彩票代表 / 彩票团队）的公共逻辑
// 子类只需实现 roleApi()（入驻彩种选项来源）和 submitApi(data)（提交接口）
import { queryUuIdInfo } from "@/api/common";

// 上传预览图字段（本地 blob），key 与 form 字段一一对应
export const IMG_FIELDS = [
  "identityCardFront",
  "identityCardBack",
  "avatar",
  // 投注站专属截图（旧版中奖相关，保留兼容）
  "tenWinNineFile",
  "tenWinSevenFile",
  "ssqEightWinFiveFile",
  "dltEightWinFiveFile",
  "holdingLicense",
  "bettingShopLicense",
  "bettingShopFacadePhoto",
  "bettingShopIndoorPhoto",
  // 双色球/大乐透中奖截图复用上方 tenWinSevenFile / tenWinNineFile
  // 投注站新版字段
  "noCrimeCertificate", // 无犯罪记录证明
];

// 上传字段名 -> 后台 fileType
const FILE_TYPE_MAP = {
  identityCardFront: "id_card_front",
  identityCardBack: "id_card_back",
  avatar: "avatar",
  tenWinNineFile: "ten_win_nine",
  tenWinSevenFile: "ten_win_seven",
  ssqEightWinFiveFile: "ssq_eight_win_five",
  dltEightWinFiveFile: "dlt_eight_win_five",
  holdingLicense: "holding_license",
  bettingShopLicense: "betting_shop_license",
  bettingShopFacadePhoto: "betting_shop_facade",
  bettingShopIndoorPhoto: "betting_shop_indoor",
  noCrimeCertificate: "criminal_record_proof",
};

function createShowImg() {
  const obj = {};
  IMG_FIELDS.forEach((k) => {
    obj[k] = "";
  });
  return obj;
}

export default {
  data() {
    return {
      saveBtnLoading: false,
      loading: false,
      curField: "",
      uploadingField: "", // 当前正在上传的字段（单个上传卡片 loading 用）

      // 入驻彩种下拉选项
      select: {
        arr: [],
      },

      // 上传预览图（本地 blob）
      showImg: createShowImg(),

      form: {
        id: "",
        nickname: "", // 用户昵称
        phoneNumber: "", // 手机号
        identityCardName: "", // 真实姓名
        identityCardNo: "", // 身份证号
        lotteryTypes: [], // 入驻彩种（角色Id数组）
        identityCardFront: "", // 身份证正面照片
        identityCardBack: "", // 身份证背面照片
        avatar: "", // 头像
        groupChat: "", // 是否有60人以上QQ/微信群

        // ===== 投注站专属（旧版缩水师字段，保留兼容） =====
        bettingShopManager: "", // 是否有投注站
        bettingShop: "", // 投注站地址
        shrinkTime: "1", // 研究缩水年限 1/2/3/4
        studyTime: "", // 研究时间
        customSoftware: "0", // 是否每年定制软件 1/0
        addSoftware: "0", // 是否不定期添置好用软件 1/0
        isVBAExcel: "0", // 是否能做VBA Excel 1/0
        doubleColorBall: "", // 双色球中奖情况
        dlt: "", // 大乐透中奖情况
        fucai3d: "", // 福彩3D中奖情况
        pailieSan: "", // 排列三中奖情况
        freeCount: "", // 免费
        payCount: "", // 付费
        isTenWinSeven: "0", // 是否10中7 1/0
        isSsqEightWinFive: "0", // 双色球是否10中7 8中5 1/0
        isDltEightWinFive: "0", // 大乐透是否10中7 8中5 1/0
        tenWinNineFile: "", // 10中9截图
        tenWinSevenFile: "", // 10中7截图
        ssqEightWinFiveFile: "", // 双色球10中7 8中5截图
        dltEightWinFiveFile: "", // 大乐透10中7 8中5截图
        holdingLicense: "", // 手持营业执照
        bettingShopLicense: "", // 营业执照
        bettingShopFacadePhoto: "", // 门面照
        bettingShopIndoorPhoto: "", // 室内照
        cognition: "", // 对缩水师的认识
        remark: "", // 个人说明

        // ===== 投注站新版字段 =====
        noCrimeCertificate: "", // 无犯罪记录证明
        shopPersonalDescription: "", // 投注站入驻个人说明
        bettingShopAddress: "", // 投注站地址（新版）
        bettingShopNumber: "", // 投注站编号
        shopDeclaration: "", // 投注站站长彩票宣言

        // ===== 代表/团队专属 =====
        personalDescription: "", // 彩票代表入驻个人说明
        isBettingShopManager: "", // 是否是投注站站长
        dingTalkNumber: "", // 钉钉号
        isSsqWin10in7: "0", // 是否最近10期双色球围4蓝10中7期 1/0
        isDltWin10in9: "0", // 是否最近10期大乐透后区3围10中9期 1/0

        // ===== 公共 =====
        qqNumber: "", // qq号
        wechatNumber: "", // 微信号
        birthday: "", // 生日
        gender: "0", // 性别 0男1女2未知
        story: "", // 小故事
        neededAssist: "", // 希望平台给予的帮扶
        motto: "", // 座右铭
      },

      rules: {
        nickname: {
          required: true,
          message: "请输入用户名/昵称",
          trigger: "change",
        },
        phoneNumber: {
          required: true,
          message: "请输入有效的中国大陆手机号码",
          trigger: "change",
          validator: (rule, value, callback) => {
            const phonePattern = /^1[3456789]\d{9}$/;
            if (!phonePattern.test(value)) {
              callback(new Error("请输入有效的中国大陆手机号码"));
            } else {
              callback();
            }
          },
        },
        identityCardName: {
          required: true,
          message: "请输入真实姓名",
          trigger: "change",
        },
        identityCardNo: {
          required: true,
          message: "请输入身份证号",
          trigger: "change",
          validator: (rule, value, callback) => {
            const idCardPattern = /(^\d{15}$)|(^\d{17}(\d|X|x)$)/;
            if (!idCardPattern.test(value)) {
              callback(new Error("请输入正确的身份证号"));
            } else {
              callback();
            }
          },
        },
        lotteryTypes: {
          required: true,
          message: "请选择入驻彩种",
          trigger: ["change", "blur"],
        },
        identityCardFront: {
          required: true,
          message: "请上传身份证正面",
          trigger: "change",
        },
        identityCardBack: {
          required: true,
          message: "请上传身份证反面",
          trigger: "change",
        },
      },
    };
  },

  mounted() {
    // 取 uuid（上传图片用）
    queryUuIdInfo().then((res) => (this.form.id = res));
    // 加载对应申请类型的角色列表（入驻彩种选项）
    this.loadRoleList();
  },

  methods: {
    // 入驻彩种选项来源，子类实现
    roleApi() {
      return Promise.resolve([]);
    },

    // 提交接口，子类实现
    submitApi() {
      return Promise.resolve({});
    },

    loadRoleList() {
      this.roleApi()
        .then((res) => {
          // res.data 可能为空/非数组，先做守卫，避免同步 TypeError（.catch 抓不到）
          const list = Array.isArray(res.data) ? res.data : [];
          // 入驻彩种过滤，交给 filterRoleList（子类可重写）
          this.select.arr = this.filterRoleList(list);
        })
        .catch(() => {
          this.select.arr = [];
        });
    },

    // 入驻彩种过滤，子类可重写。
    // 默认仅保留大乐透、双色球两个缩水师角色（投注站页沿用）。
    filterRoleList(list) {
      const allow = [
        "role_fc_dlt_shrinkage_engineer",
        "role_fc_ssq_shrinkage_engineer",
      ];
      return list.filter((item) => allow.includes(item.roleKey));
    },

    // 上传图片（field 为 form 中对应的字段名）
    // loading 与 uploadingField 同时置位：
    //   - uploadingField 给 UploadCard 用（投注站/代表页，只在当前卡片内转圈）
    //   - loading 给整页 v-loading 用（团队页仍是旧版上传，无卡片内 loading）
    chooseImg(e, field) {
      if (!e || !e.raw) return;
      const fd = new FormData();
      fd.append("file", e.raw);

      const ft = FILE_TYPE_MAP[field] || field;
      const params = `?fileType=${ft}&bizId=${this.form.id}&number=${ft}`;

      this.loading = true;
      this.uploadingField = field;
      this.$utils
        .upLoadFile(params, fd)
        .then((res) => {
          this.form[field] = res.data.urls;
          this.showImg[field] = this.$utils.fileToBolb(e.raw);
          this.loading = false;
          this.uploadingField = "";
        })
        .catch(() => {
          this.loading = false;
          this.uploadingField = "";
        });
    },

    // 删除已上传图片（清空 form 值 + 本地预览）
    removeImg(field) {
      this.form[field] = "";
      this.showImg[field] = "";
    },

    submit() {
      // 规整入驻彩种 lotteryTypes 为数字数组：
      // 兼容单选/多选、字符串/数字/对象，规避 Array(31)=长度31空数组、Array([31])=[[31]] 嵌套的坑
      const raw = this.form.lotteryTypes;
      this.form.lotteryTypes = (Array.isArray(raw) ? raw : [raw])
        .map((v) => (typeof v === "object" && v ? Number(v.id) : Number(v)))
        .filter((n) => n !== 0 && !Number.isNaN(n));

      this.$refs.form.validate((valid) => {
        if (!valid) {
          this.$message.error("请完善必填项");
          return;
        }
        this.saveBtnLoading = true;
        this.submitApi(this.form)
          .then((res) => {
            this.saveBtnLoading = false;
            if (res && res.code == 200) {
              this.$message.success("申请成功，请耐心等待1-5个工作日");
              this.resetForm();
            } else {
              this.$message.error((res && res.msg) || "提交失败");
            }
          })
          .catch(() => {
            this.saveBtnLoading = false;
          });
      });
    },

    resetForm() {
      this.$refs.form.resetFields();
      this.showImg = createShowImg();
      queryUuIdInfo().then((res) => (this.form.id = res));
    },
  },
};
